import React, { useEffect } from 'react'
import upwork from '../img/upwork.png'
import fiver from '../img/fiver.png'
import genshin from '../img/genshin.jfif'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import CSSRulePlugin from 'gsap/CSSRulePlugin'

function Contact() {
  
  useEffect(() => {

    gsap.registerPlugin(ScrollTrigger,CSSRulePlugin);

    gsap.to('.s2-media',{
      opacity:1,
      ease:"none",
      duration:2,
      stagger:0.25,
      scrollTrigger:{
        trigger:"#contact",
      }
    })    
    gsap.to('.s-media .hide h3',{
      y:0,
      ease:"none",
      duration:2,
      stagger:0.25,
      scrollTrigger:{
        trigger:"#contact",
      }
    })    

  },[])
  
  return (  
    <div className='contact' id='contact'>
      <div className="s-media">
        <div className="hide">
          <h3>
            Social-media
          </h3>
        </div>
      </div>
      <div className="s2-media">
        <a href='#' className="link-media">
          <ion-icon name="logo-instagram"></ion-icon>
          <div className="text">
            x_e_n_e_x_1_2
          </div>
        </a>
        <a href='#' className="link-media">
          <ion-icon name="logo-facebook"></ion-icon>
          <div className="text">
            myt.vince.3
          </div>
        </a>
        <a href='#' className="link-media">
          <ion-icon name="logo-twitter"></ion-icon>
          <div className="text">
            MXenodo
          </div>
        </a>
        <a href='#' className="link-media">
          <ion-icon name="logo-discord"></ion-icon>
          <div className="text">
            xenex#1111
          </div>
        </a>
      </div>
      <div className="s-media">
        <div className="hide">
          <h3>
            Work Account/Contact
          </h3>
        </div>
      </div>
      <div className="s2-media">
        <a href='#' className="link-media">
          <ion-icon name="logo-google"></ion-icon>
          <div className="text">
            mythicalxenon12@gmail.com
          </div>
        </a>
        <a href='https://www.upwork.com/freelancers/~01ae940e55a1326fc0' className="link-media">
          <img src={upwork} alt="" />
          <div className="text">
          ~01ae940e55a1326fc0
          </div>
        </a>
        <a href='https://business.fiverr.com/users/mythxenodo/seller_dashboard' className="link-media">
          <img src={fiver} alt="" />
          <div className="text">
            mythxenodo
          </div>
        </a>
        <a href='https://business.fiverr.com/users/mythxenodo/seller_dashboard' className="link-media">
          <ion-icon name="call-outline"></ion-icon>
          <div className="text">
            09633266195
          </div>
        </a>
      </div>
      <div className="s-media">
        <div className="hide">
          <h3>
            Game ID
          </h3>
        </div>
      </div>
      <div className="s2-media">
        <a href='#' className="link-media">
          <img src={genshin} alt="" />
          <div className="text">
            812962056
          </div>
        </a>
      </div>
    </div>
  
  )
}

export default Contact